/*
 * This variable is automatically overwritten during builds and releases.
 * It doesn't need to be updated manually.
 */

var version = '4.7.0';

export { version };
//# sourceMappingURL=common/govuk-frontend-version.mjs.map
